/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports DKA.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {

		// check browser
	    var ua = window.navigator.userAgent;
	    var msie = ua.indexOf("MSIE ");
	    var isMobile = document.getElementById('mobileHeader').offsetParent; // see if mobile header is visible

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer
		{
			var isIE = true;
		}
		else  // If another browser, return 0
		{
			var isIE = false;
			module.aos();
		}

		module.smoothScroll();
		module.setupMainNav();
		module.setupMobileNav(isIE);
		module.setupStickyNav(isMobile);
		module.setupSideNav(isMobile);
		module.setupSwiper();
		module.setupSwiperTimeline();	
		module.setupVideoModal();	
		module.externalLinks();

		window.addEventListener("resize", function() {
			isMobile = document.getElementById('mobileHeader').offsetParent;
			module.setupMobileNav(isIE);
			module.setupStickyNav(isMobile);			
			// module.setupSideNav(isMobile); // removing due to mobile calling this on scroll/change browser chrome -- may need a different solution but will wait for QA
		});
	};

	module.smoothScroll = function () {
		// Add smooth scrolling to all links
		jQuery("a").on('click', function(event) {

			// Make sure this.hash has a value before overriding default behavior
			// ok to override default if we are not linking to a collection
			if ( this.hash !== "" ) {

				// var pathname = window.location.pathname;
				var href = jQuery(this).attr('href'); 

				// if (href.includes('/products/#') === false)  {	
				if ( href.indexOf('/products/#') === -1 )  {	
					// Prevent default anchor click behavior
					event.preventDefault();

					// Store hash
					var hash = this.hash;

					// Using jQuery's animate() method to add smooth page scroll
					// The optional number (400) specifies the number of milliseconds it takes to scroll to the specified area
					jQuery('html, body').animate({ scrollTop: jQuery(hash).offset().top-50 }, 400);
				}
				
			} // End if
		  });
	}

	module.aos = function () {
 		AOS.init();
	};

	module.setupMainNav = function () {

		// get each top level menu item
		var parent = document.getElementsByClassName("sub-menu__heading");

 		for (var i = 0; i < parent.length; i++) {
 			// save our rotated text value so we can calculate the length
 			var rotatedText = parent[i].firstElementChild.textContent;
 			 
 			// save our rotated items' parent so we can adjust it's top position
 			var rotatedParent = parent[i].firstElementChild;

			var c = document.createElement("canvas"); // create our canvas
			var ctx = c.getContext("2d"); 
			ctx.font = '400 72px Poppins'; // dropping font size here slightly to tweak positioning
			rotatedParent.style.top = ctx.measureText(rotatedText).width + "px";
 		}
	};

	module.setupSideNav = function( isMobile ) {

		// add event listener to filtering/sidenav anchor items
		var sideNavLinks = document.getElementsByClassName('js-sidenav-link');
		var filteringLinks = document.getElementsByClassName('js-filter-vertical');

		if (!sideNavLinks || !filteringLinks ) return false;

		if ( sideNavLinks.length > 0 ) {

			var setSideNavActive = function() {
			
				var sideNavSelected = document.querySelector('.selected-sidenav');

				// clear our selected class 
				if (sideNavSelected) {
					sideNavSelected.classList.remove('selected-sidenav');				
				}

				this.classList.add('selected-sidenav');
			}

			// set our threshold for our intersection observer based on viewport
			// want our threshold to be greater on larger screens
			let intViewportWidth = window.innerWidth;
			let intViewportHeight = window.innerHeight;

			if (intViewportWidth < 500) {
				var sideNavThreshold = .4;
			} else {
				var sideNavThreshold = .9;
			}

			for (var i = 0; i < sideNavLinks.length; i++) {

				// to add active state on our element
				sideNavLinks[i].addEventListener('click', setSideNavActive, false);

				// set up our intersection observer by passing in the ID of our containers to watch
				var observerElement = document.querySelector(sideNavLinks[i].getAttribute("href"));

				// create the observer for the element
				createObserver(observerElement);
			} 

		} else {
			for (var i = 0; i < filteringLinks.length; i++) {
				filteringLinks[i].addEventListener('click', handleFiltering, false);				
			}
		}

		function createObserver( el ) {
			let observer; 
			
			let options = {
				root: null,
				rootMargin: "0px",
				threshold: sideNavThreshold
				// threshold: .5 // 50% visible
				// threshold: 1 // in full view
			};

		  observer = new IntersectionObserver(handleIntersect, options);
		  observer.observe( el );
		}
 
		function handleIntersect(entries, observer) {
 
			entries.forEach((entry) => {

				var item = document.querySelector('a[href="#' + entry.target.id + '"]'); 

				// if 1, item is in full view
				if (entry.intersectionRatio >= sideNavThreshold) {

				  	// item = document.querySelector('a[href="#' + entry.target.id + '"]');
					item.classList.add('selected-sidenav');
					item.parentNode.classList.add('selected-sidenav-parent');

				} else {
				   
				  	item.classList.remove('selected-sidenav');
					item.parentNode.classList.remove('selected-sidenav-parent'); 

				}				
			});		


			// every time intersection observer makes a changes, verify we have our first .selected-sidenav parent selected
			// we need only the first so we don't have multiple selected states			
			if (document.querySelectorAll(".selected-sidenav-first").length > 0) {
				document.querySelector(".selected-sidenav-first").classList.remove("selected-sidenav-first");
			}

			var nodes = document.querySelectorAll(".selected-sidenav-parent");			
			// var last = nodes[nodes.length- 1];
			var first = nodes[0];			
			var sideNavWrapper = document.getElementById('sidenav');
			var listWrapper = document.getElementById('sidenav-list');
 
			if (first) {
				first.classList.add('selected-sidenav-first');

				// if this is not mobile or we don't have a sidenav, no need to center element
				if (!sideNavWrapper || !isMobile ) return false;
				
				centerOnElement(first);				
			}
		}

		function handleFiltering(el) {
			
			el.preventDefault(); 
			
			// add filtering for this item
			var verticalToShow = this.getAttribute('data-filterby');
			var verticalList = document.querySelector('.selected-filter');
			var productDetails = document.getElementsByClassName("js-product-detail"); 

			// if user clicks the already selected filter, turn off filter
			if (this == verticalList) {
				
				for (var i = 0; i < productDetails.length; i++) {

					productDetails[i].classList.remove('hide');						 
					productDetails[i].classList.remove('show');	
					verticalList.classList.remove('selected-filter');						
				}

			// otherwise, turn on this filter
			} else {

				// see if our product details column has the vertical applied to it's data attribute			
				// iterate each product detail column
				for (var i = 0; i < productDetails.length; i++) {
					
					var assignedVerticals = productDetails[i].getAttribute("data-verticals");
									
					// if ( assignedVerticals.includes(verticalToShow) === true ) {
					if ( assignedVerticals.indexOf(verticalToShow) > -1 ) {
						productDetails[i].classList.remove('hide');
						productDetails[i].classList.add('show');
					} else {
						productDetails[i].classList.remove('show');
						productDetails[i].classList.add('hide');
					}
				}

				this.classList.add('selected-filter');

				if (verticalList) {
					verticalList.classList.remove('selected-filter');
				}

				// if mobile, center the element in view
				// if this is not mobile or we don't have a sidenav, no need to center element
				if ( !isMobile ) return false;
				
				centerOnElement(this.parentNode);
			}
		};

		// mobile sidenav make sure we center the active element
		// param el: is item to be centered
		function centerOnElement(el){		 

			let listPos = 0;
			let elPos = el.offsetLeft;
			let elWidth = el.offsetWidth;
			let navWidth = document.getElementById('sidenav').offsetWidth;
			let parentWidth = el.parentNode.offsetWidth;
			let listWrapper = document.getElementById('sidenav-list'); //el.parentNode;

			// only center the item if there is overflow
			if ( listWrapper.scrollWidth > listWrapper.offsetWidth ) {

				listPos = -elPos + (parentWidth / 2) - (elWidth / 2);

				if ( listPos > 0 ) {
					listPos = 0;
				}

				listWrapper.style.transform = "translateX(" + listPos + "px)";

				// give the transform a second to apply
				setTimeout(function(){ 
					module.updateSidenavButtons(listWrapper); 
				 }, 1000);
			}
		}

	};

	module.setupMobileNav = (isIE) => {

		let mobileNavTrigger = document.getElementById('mobileNavTrigger');
		let headerWrapper = document.getElementById('headerWrapper');
		
		if (!mobileNavTrigger || isIE===true ) return false;
		
		mobileNavTrigger.addEventListener('click', (event) => {

			if ( mobileNavTrigger.classList.contains('icon-hamburger') ) {
				mobileNavTrigger.classList.remove('icon-hamburger');
				mobileNavTrigger.classList.add('icon-close');
			} else {
				mobileNavTrigger.classList.remove('icon-close');
				mobileNavTrigger.classList.add('icon-hamburger');
			}

			if ( headerWrapper.classList.contains('header__wrapper--active') ) {
				headerWrapper.classList.remove('header__wrapper--active');
				document.body.classList.remove('state-fixed');
				
			} else {
				headerWrapper.classList.add('header__wrapper--active');
				document.body.classList.add('state-fixed');
				
			}
		});
 
 		// handle mege menu on large touch devices
 		// check for touch device and confirm this is not IE
		if ( ("ontouchstart" in window || navigator.msMaxTouchPoints) && ( !isIE ) ) {		    
		    // check to see if mobile nav is visible
		    if (mobileHeader.offsetParent === null) {
		    	
		    	// get all of the top nav elements
		    	var navElements = document.getElementsByClassName("js-main-nav");

				// function to show/hide nav for touch
				var handleTouchMegaMenu = function() {
					event.preventDefault(); // don't link to the page when item is clicked

				    var navElement = event.target;

				    // listen for focus out so we can remove our active element
					navElement.addEventListener('focusout', (event) => { 
					 	navElement.classList.remove('main-navigation__active'); 
					});

					// if they click an active item again, hide the mega menu
					if (navElement.classList.contains('main-navigation__active')) { 
				    	event.target.classList.remove('main-navigation__active');
				    	navElement.nextElementSibling.style.height = '0';
				    } else { // if they click an item that isn't active
				    	//remove all other active classes
				    	var activeItems = document.getElementsByClassName('main-navigation__active');
						for (var i = 0; i < activeItems.length; i++) {
						   activeItems[i].classList.remove('main-navigation__active');
						}
						// activate the one they clicked
				    	event.target.classList.add('main-navigation__active');
				    	// navElement.nextElementSibling.style  = '';
				    	navElement.nextElementSibling.removeAttribute('style');
				    }


				    // listen for scrolling and close menu if they do
				    document.addEventListener('scroll', function(e) {
					 	navElement.classList.remove('main-navigation__active'); 
  						navElement.nextElementSibling.style.height = '0';
					});
					
				}

		    	// add click listeners for each top nav element
				for (var i = 0; i < navElements.length; i++) {					
					navElements[i].firstChild.addEventListener('click', handleTouchMegaMenu, false);				    
				}
		    }
		} 
		
	};

	module.updateSidenavButtons = function( list ) {  

		let rightArrow = document.querySelector(".sidenav__button--right");
		let leftArrow = document.querySelector(".sidenav__button--left");
		let xMax = 0; // to keep the list pinned to the left side
		
		// xMin is width of the list minus the width of the container - last item, negated
		// let xMin = -(list.scrollWidth - list.offsetWidth - list.lastElementChild.scrollWidth );
		let xMin = -( list.scrollWidth - list.offsetWidth );
		let currentX = 0;


		// need to account from our transfrom value on our list
		// get 2D transform value from computed styles
		let style = window.getComputedStyle(list)
		let matrix = style.transform || style.webkitTransform || style.mozTransform

		// if we have a transform value on the list, add it to the position
		// assumes this is a 2d transform
		if (matrix !== 'none') {	
			const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
			currentX = matrixValues[4];  
		}

		// if our current position is greater than 0
 		if ( currentX >= xMax ){
 			leftArrow.classList.remove('show');
 		} else {
 			leftArrow.classList.add('show');
 		}

 		// if our current position is less than our calculated min
 		if ( currentX <= xMin ){
 			rightArrow.classList.remove('show');
 		} else {
 			rightArrow.classList.add('show');
 		}
	};

	module.setupStickyNav = function( isMobile ) {

		// check to see if the page has a sidenav module and is mobile		        
		let sideNavWrapper = document.getElementById('sidenav');		 

		// if this is not mobile or we don't have a sidenav, go away
		if (!sideNavWrapper || !isMobile ) return false;

		let scrollElements = document.getElementsByClassName("js-scroll-nav"); 
		let sideNavList = document.getElementById('sidenav-list');
		var rightArrow = document.querySelector(".sidenav__button--right");
		var leftArrow = document.querySelector(".sidenav__button--left");
		var listWrapper = document.getElementById('sidenav-list');
		var scrollTally = 0;


 		// listen for scrolling and add sticky class when sidenav reaches top
 		// remove sticky class when user scrolls back to top
		document.addEventListener('scroll', function(){	
			
			var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
			
			if ( sideNavWrapper.getBoundingClientRect().top < 0 ){
				sideNavWrapper.classList.add('sticky');
			}
			if ( scrollPos < 10 ) {
				sideNavWrapper.classList.remove('sticky');
			}

			module.updateSidenavButtons(sideNavList);
		});

		Array.from(scrollElements).forEach(function(scrollElement) {
			scrollElement.addEventListener('click', navClick); 
		});

		function navClick() {

			// scroll 1/3 viewport width left or right
			let scrollWidth = window.innerWidth / 3;
			let navList = document.getElementById('sidenav-list');
			let translateMin = -(navList.scrollWidth - navList.offsetWidth); 

 			if (this.classList.contains('sidenav__button--left')){
 				if ( scrollTally < 0 ){
					scrollTally += scrollWidth;
 					// rightArrow.classList.add('show');
 				}			
 			} else {
 				if ( scrollTally > translateMin ){
					scrollTally -= scrollWidth;
					// leftArrow.classList.add('show');
 				}				
 			}

			listWrapper.style.transform = "translateX(" + scrollTally + "px)";

			// give the transform a second to apply
			// then update buttons
			setTimeout(function(){ 
				module.updateSidenavButtons(listWrapper); 
			 }, 1000);
		}
		
		// for our initial load
		module.updateSidenavButtons(sideNavList);
	};

	module.setupSwiper = function() {
		//var carousels = document.getElementsByClassName('.swiper-container');

		jQuery('.swiper-container').each(function(index, element){
			var swiperID = jQuery(this).data('id');		

			new Swiper('.id-'+swiperID, {
				loop: true,
				navigation: {
					nextEl: ('.swiper-button-next-'+swiperID),
					prevEl: ('.swiper-button-prev-'+swiperID),
				},
				pagination: {
					el: '.swiper-pagination-'+swiperID,
					clickable: true,
					renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + '</span>';
					},
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
			});
		});		
	};

	module.setupSwiperTimeline = function() {
		//var carousels = document.getElementsByClassName('.swiper-container');

		jQuery('.swiper-timeline-container').each(function(index, element){
			new Swiper('.js-swiperTimeline', {
				loop: true,
				navigation: {
					nextEl: ('.swiper-button-next-swiperTimeline'),
					prevEl: ('.swiper-button-prev-swiperTimeline'),
				},
				pagination: {
					el: '.swiper-pagination-swiperTimeline',
					clickable: true,
					renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + '</span>';
					},
				},
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 32,
				loopFillGroupWithBlank: true,
				speed: 300,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						speed: 500				},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						speed: 700,
					}
				}
			});
		});		
	};

	module.setupVideoModal = function(){
		jQuery('#videoModal').on('show.bs.modal', function (event) {
			var button = jQuery(event.relatedTarget);
			var title = button.data('title');
			var url = button.data('link');
			var modal = jQuery(this);
			modal.find('.modal-title').text(title);
			modal.find('.modal-video').attr('src',"https://www.youtube.com/embed/"+url+"?&autoplay=1");
		})

		jQuery('#videoModal').on('hidden.bs.modal', function (event) {
			var modal = jQuery(this);
			modal.find('.modal-video').attr('src',"");
		})
	}

	module.externalLinks = function () {

		jQuery.expr[':'].external = function(obj){
		    return !obj.href.match(/^mailto\:/)
		           && (obj.hostname != location.hostname)
		           && !obj.href.match(/^javascript\:/)
		           && !obj.href.match(/^$/)
		};
		jQuery('a:external').attr({target: "_blank", rel: "noopener"}); 
	};


	var docReady = function docReady(callback) {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
		// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
		// IE <= 8
			document.attachEvent('onreadystatechange', function () {
				if (document.readyState === 'complete') callback();
			});
		}
	};
	
	docReady(() => {
		module.init();
		//HBS.initPage();
	});

	HBS.namespace('DKA.main', module);
}());